/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { teacherPaymentControllerSearch } from '../fn/teacher-payment/teacher-payment-controller-search';
import { TeacherPaymentControllerSearch$Params } from '../fn/teacher-payment/teacher-payment-controller-search';

@Injectable({ providedIn: 'root' })
export class TeacherPaymentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `teacherPaymentControllerSearch()` */
  static readonly TeacherPaymentControllerSearchPath = '/api/teacher-payment';

  /**
   * 결제 목록 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teacherPaymentControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  teacherPaymentControllerSearch$Response(params: TeacherPaymentControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return teacherPaymentControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 결제 목록 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teacherPaymentControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  teacherPaymentControllerSearch(params: TeacherPaymentControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.teacherPaymentControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

}
